import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from '../../forum/app';
import PaginatedListState from '../../common/states/PaginatedListState';
import EventEmitter from '../../common/utils/EventEmitter';
const globalEventEmitter = new EventEmitter();
export default class PostListState extends PaginatedListState {
  constructor(params, page, pageSize) {
    if (page === void 0) {
      page = 1;
    }
    if (pageSize === void 0) {
      pageSize = null;
    }
    super(params, page, pageSize);
    _defineProperty(this, "extraPosts", []);
    _defineProperty(this, "eventEmitter", void 0);
    this.eventEmitter = globalEventEmitter;
  }
  get type() {
    return 'posts';
  }
  requestParams() {
    var _this$params$sort;
    const params = {
      include: ['user', 'discussion'],
      filter: _objectSpread({
        type: 'comment'
      }, this.params.filter || {}),
      sort: this.sortMap()[(_this$params$sort = this.params.sort) != null ? _this$params$sort : ''] || '-createdAt'
    };
    if (this.params.q) {
      params.filter.q = this.params.q;
    }
    return params;
  }
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const preloadedPosts = app.preloadedApiDocument();
    if (preloadedPosts) {
      var _preloadedPosts$paylo;
      this.initialLoading = false;
      this.pageSize = ((_preloadedPosts$paylo = preloadedPosts.payload.meta) == null ? void 0 : _preloadedPosts$paylo.perPage) || PostListState.DEFAULT_PAGE_SIZE;
      return Promise.resolve(preloadedPosts);
    }
    return super.loadPage(page);
  }
  clear() {
    super.clear();
    this.extraPosts = [];
  }

  /**
   * Get a map of sort keys (which appear in the URL, and are used for
   * translation) to the API sort value that they represent.
   */
  sortMap() {
    const map = {};
    if (this.params.q) {
      map.relevance = '';
    }
    map.newest = '-createdAt';
    map.oldest = 'createdAt';
    return map;
  }
  getAllItems() {
    return this.extraPosts.concat(super.getAllItems());
  }
  getPages() {
    const pages = super.getPages();
    if (this.extraPosts.length) {
      return [{
        number: -1,
        items: this.extraPosts
      }, ...pages];
    }
    return pages;
  }
}
flarum.reg.add('core', 'forum/states/PostListState', PostListState);